/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { SortCriteriaItem } from './base.types';

export interface RxInterceptRule {
  id: number;
  priority: RulePriority;
  userId: number;
  userName: string;
  locationId: number;
  locationName: string;
  medicationGroupId: number;
  medicationGroupDescription: string;
  interceptRate: number;
  isEnabled: boolean;
  isArchived: boolean;
  startDate: Date;
  endDate: Date;
  startTime: string;
  endTime: string;
  startDateTime: Date;
  endDateTime: Date;
  archivedTime: Date;
  daysOfWeek: DaysOfWeek;
}

export interface UpsertRxInterceptRuleRequest {
  id: number | null;
  priority: RulePriority | null;
  userId: number | null;
  locationId: number | null;
  medicationGroupId: number | null;
  interceptRate: number | null;
  startDate: Date | null;
  endDate: Date | null;
  startTime: string | null;
  endTime: string | null;
  daysOfWeek: DaysOfWeek | null;
}

export enum RulePriority {
  None = 0,
  Low = 1,
  Medium = 2,
  High = 4,
}

export function getPriorityLetter(value: RulePriority): string {
  switch (value) {
    case RulePriority.High:
      return 'H';
    case RulePriority.Medium:
      return 'M';
    case RulePriority.Low:
      return 'L';
    default:
      return '';
  }
}

export enum DaysOfWeek {
  None = 0,
  Sunday = 1,
  Monday = 2,
  Tuesday = 4,
  Wednesday = 8,
  Thursday = 16,
  Friday = 32,
  Saturday = 64,
}

export const EVERY_DAY =
  DaysOfWeek.Sunday |
  DaysOfWeek.Monday |
  DaysOfWeek.Tuesday |
  DaysOfWeek.Wednesday |
  DaysOfWeek.Thursday |
  DaysOfWeek.Friday |
  DaysOfWeek.Saturday;

export const DAYS_MAP = [
  { name: 'M', value: DaysOfWeek.Monday },
  { name: 'T', value: DaysOfWeek.Tuesday },
  { name: 'W', value: DaysOfWeek.Wednesday },
  { name: 'Th', value: DaysOfWeek.Thursday },
  { name: 'F', value: DaysOfWeek.Friday },
  { name: 'Sa', value: DaysOfWeek.Saturday },
  { name: 'Su', value: DaysOfWeek.Sunday },
];

export enum RxInterceptRuleSortCriteria {
  Priority,
  User,
  Location,
  MedicationGroup,
  InterceptRate,
  StartDate,
  EndDate,
  Enabled,
}

export type RxInterceptRuleCriteriaItem = SortCriteriaItem<typeof RxInterceptRuleSortCriteria>;

export interface QueryRxInterceptRulesRequest {
  users?: number[];
  locations?: number[];
  medicationGroup?: number[];
  sortCriteria?: RxInterceptRuleCriteriaItem[];
  isArchived: boolean;
}
